import React from "react";
import FincludeLogo from "../../assets/images/finclude.png";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import useLogout from "../common/useLogout";
import useMobileView from "../common/useMobileView";

const Header = ({ currentUser }) => {
  const [handleBurgerButton, openMobileClass] = useMobileView("");
  const [handleLogout] = useLogout();

  return (
    <div className={openMobileClass}>
      <nav className={`header-nav px-3 px-md-4 px-lg-5 py-3 py-sm-4`}>
        <Link className="navbar-brand mr-md-4" to="/">
          <img src={FincludeLogo} alt="Finclude" />
        </Link>
        <button
          className="navbar-toggle"
          onClick={(e) => handleBurgerButton(e)}
        >
          <span className="navbar-toggle-icon" />
        </button>
        <div className="mobile-nav-menu">
          <button
            className="navbar-close"
            onClick={(e) => handleBurgerButton(e)}
          >
            <span className="navbar-close-icon" />
          </button>
          <ul className="mobile-navbar-nav">
            {/*<li className="nav-item">*/}
            {/*  <Link className="nav-link " to="/">*/}
            {/*    Dashboard*/}
            {/*  </Link>*/}
            {/*</li>*/}
            <li className="nav-item">
              <Link to="/" className="nav-link">
                Organizations
              </Link>
            </li>
            <li className="nav-item">
              <Link to="/super-admins" className="nav-link">
                Super Admins
              </Link>
            </li>
            {/*<li className="nav-item">*/}
            {/*  <Link to="/uploads" className="nav-link">*/}
            {/*    Uploads*/}
            {/*  </Link>*/}
            {/*</li>*/}
            {/*<li className="nav-item">*/}
            {/*  <Link to="/audit-logs" className="nav-link">*/}
            {/*    Logs*/}
            {/*  </Link>*/}
            {/*</li>*/}
          </ul>
          <ul className="mobile-navbar-nav ml-auto">
            {/*<li className="nav-item">*/}
            {/*  <Link to="/tickets" className="nav-link">*/}
            {/*    Support <sup className="badge badge-main">4</sup>*/}
            {/*  </Link>*/}
            {/*</li>*/}
            <li className="nav-item dropdown">
              <a
                className="nav-link dropdown-toggle"
                href="#"
                id="navbarDropdown"
                role="button"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                My account
              </a>
              <div className="dropdown-menu dropdown-menu-right">
                <span className="dropdown-item">
                  <strong>{currentUser.fullName}</strong>
                </span>
                <div className="dropdown-divider" />
                <Link className="dropdown-item" to="/profile">
                  Profile Settings
                </Link>
                <Link
                  className="dropdown-item"
                  to="/login"
                  onClick={() => handleLogout()}
                >
                  Logout
                </Link>
              </div>
            </li>
          </ul>
        </div>
      </nav>
    </div>
  );
};

Header.propTypes = {
  queryClient: PropTypes.object.isRequired,
  currentUser: PropTypes.object.isRequired,
};

export default Header;
